import { viewModel } from "./viewModel";
import { createContext } from "react";
import type { FakeViewModelContext } from "./types";

export const defaultViewModelContext: FakeViewModelContext = {
  viewModel,
  overrides: {},
};

export const ViewModelContext = createContext(defaultViewModelContext);
